let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let FormMixin = require("react-loose-forms");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let ezVerticalFields = require("react-loose-forms.bootstrap3/layouts/ezVerticalFields");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let FormUtils = require("../../../utils/FormUtils");
let DisplaylistSpeaker_to_actionlistSaveData = require("./DisplaylistSpeaker_to_actionlistSaveData");

let NewActionListForm = dd.createClass({
    mixins: [FormMixin],
    buildSchema: function(){
        return {
            name: {
                label: "List Name",
                type: "text",
                validate: FormUtils.v.required
            }
        };
    },
    render: function(){
        let onClose = this.props.onClose;
        return dd.form({onSubmit: this.Form_onSubmit},
            ezVerticalFields(this),
            dd.div({},
                dd.button({className: "btn btn-primary", type: "submit"},
                    "Add"
                ),
                " ",
                dd.button({
                    className: "btn btn-default",
                    onClick: onClose
                }, "Cancel")
            )
        );
    }
});

module.exports = dd.createClass({
    mixins: [RadioServiceMixin],
    RadioService_setup(){
        return {
            Actionlists_save: {
                key(){
                    return 1;
                },
                on: {
                    succeeded(){
                        this.props.onClose();
                    }
                }
            }
        };
    },
    __onSubmit: function(data){
        let speaker = this.props.speaker;

        let to_save = {};
        to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);

        //Add the new list
        to_save[speaker.sid][-1] = {
            name: data.name,
            items: {}
        };

        radio("Actionlists_save").broadcast(to_save);
    },
    render: function(){
        let ajax = this.state.Actionlists_save;
        let onClose = this.props.onClose;
        return Modal({
                title: "New Action Action List",
                buttons: [],
                onClose: ajax.waiting ? null : onClose
            },
            ErrorAlert({message: ajax.error}),
            LoadingWrap({is_loading: ajax.waiting, text: "Saving..."},
                NewActionListForm({
                    onClose: onClose,
                    onSubmit: this.__onSubmit
                })
            )
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/action_lists/NewActionListModal.js